export const dummyDeviceToViewportHeightDataDict = {
    ['iPhone 15']: {
        height: 852,
        browserUI: 80,
        visibleHeight: 772,
    },
    ['iPhone 12']: {
        height: 844,
        browserUI: 80,
        visibleHeight: 764,
    },
    ['iPhone 8']: {
        height: undefined,
        browserUI: undefined,
        visibleHeight: undefined,
    },
    ['Pixel 8a']: {
        height: 915,
        browserUI: 112,
        visibleHeight: 803,
    },
    ['Pixel 7']: {
        height: 915,
        browserUI: 112,
        visibleHeight: 803,
    },
    ['Pixel 6a']: {
        height: 851,
        browserUI: 112,
        visibleHeight: 739,
    },
    ['Galaxy S7']: {
        height: 640,
        browserUI: 112,
        visibleHeight: 528,
    },
    ['iPad 11 Pro']: {
        height: 1194,
        browserUI: 80,
        visibleHeight: 1114,
    },
    ['iPad']: {
        height: undefined,
        browserUI: undefined,
        visibleHeight: undefined,
    },
    ['Horizontal']: {
        height: undefined,
        browserUI: undefined,
        visibleHeight: undefined,
    },
    ['Custom']: {
        height: undefined,
        browserUI: undefined,
        visibleHeight: undefined,
    }
};
